import React from "react";
import { FootnoteDiv } from "./elements";

const Footnote = ({ reference, note }) => (
  <FootnoteDiv>
    This is a footnote! The reference is {reference} and the note is {note}. Fix
    this code!
  </FootnoteDiv>
);

export default Footnote;
